"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.legalVersion = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _translations = require("../../helpers/translations");

var _IconBtnTooltip = _interopRequireDefault(require("../IconBtnTooltip"));

var _material = require("@mui/material");

require("./LegalFooter.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var legalVersion = 'show-legal-1.0';
exports.legalVersion = legalVersion;

var LegalFooter = /*#__PURE__*/function (_React$Component) {
  _inherits(LegalFooter, _React$Component);

  var _super = _createSuper(LegalFooter);

  function LegalFooter() {
    var _this;

    _classCallCheck(this, LegalFooter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      expanded: JSON.parse(localStorage.getItem(legalVersion)) || JSON.parse(localStorage.getItem(legalVersion)) === null
    });

    return _this;
  }

  _createClass(LegalFooter, [{
    key: "showFooterSet",
    value: function showFooterSet() {
      var _this2 = this;

      this.setState({
        expanded: !this.state.expanded
      }, function () {
        localStorage.setItem(legalVersion, _this2.state.expanded);
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.expanded !== nextState.expanded;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/_react["default"].createElement("footer", {
        className: "LegalFooter_footer hideOnPrint"
      }, /*#__PURE__*/_react["default"].createElement(_material.Paper, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "LegalFooter_legalContainer"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "LegalFooter_headerContainer"
      }, /*#__PURE__*/_react["default"].createElement("h1", {
        className: "LegalFooter_header"
      }, (0, _translations.getTranslations)('legalfooter_head')), /*#__PURE__*/_react["default"].createElement(_IconBtnTooltip["default"], {
        buttonProps: {
          'aria-expanded': this.state.expanded
        },
        onClick: function onClick() {
          return _this3.showFooterSet();
        },
        icon: this.state.expanded ? 'expand_less' : 'expand_more',
        iconProps: {
          className: 'LegalFooter_arrowIcon'
        }
      })), /*#__PURE__*/_react["default"].createElement(_material.Collapse, {
        "in": this.state.expanded,
        style: this.state.expanded ? {
          display: 'block'
        } : {
          visibility: 'hidden'
        },
        tabIndex: this.state.expanded ? 0 : -1
      }, " ", /*#__PURE__*/_react["default"].createElement("div", {
        className: "LegalFooter_legalBody"
      }, /*#__PURE__*/_react["default"].createElement("p", null, (0, _translations.getTranslations)('legalfooter_p1a_text'), " ", /*#__PURE__*/_react["default"].createElement("a", {
        href: this.props.programDescriptionLink || (0, _translations.getTranslations)('legalfooter_program_desc_nav'),
        target: "_blank",
        rel: "noopener noreferrer",
        className: "LegalFooter_link"
      }, (0, _translations.getTranslations)('legalfooter_p1b_text')), (0, _translations.getTranslations)('legalfooter_p1c_text'), /*#__PURE__*/_react["default"].createElement("a", {
        href: "tel:".concat((0, _translations.getTranslations)('legalfooter_program_desc_phone_nav')),
        className: "LegalFooter_link"
      }, (0, _translations.getTranslations)('legalfooter_program_desc_phone')), (0, _translations.getTranslations)('legalfooter_p1d_text'), /*#__PURE__*/_react["default"].createElement("a", {
        href: (0, _translations.getTranslations)('legalfooter_my529_nav'),
        target: "_blank",
        rel: "noopener noreferrer",
        className: "LegalFooter_link"
      }, (0, _translations.getTranslations)('legalfooter_my529_text')), "."), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, (0, _translations.getTranslations)('legalfooter_p2_head')), (0, _translations.getTranslations)('legalfooter_p2_text')), /*#__PURE__*/_react["default"].createElement("p", null, (0, _translations.getTranslations)('legalfooter_p3a_text'), /*#__PURE__*/_react["default"].createElement("a", {
        href: (0, _translations.getTranslations)('legalfooter_fdic_nav'),
        target: "_blank",
        rel: "noopener noreferrer",
        className: "LegalFooter_link"
      }, (0, _translations.getTranslations)('legalfooter_p3b_text')), (0, _translations.getTranslations)('legalfooter_p3c_text')), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, (0, _translations.getTranslations)('legalfooter_p4_head')), (0, _translations.getTranslations)('legalfooter_p4_text')), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, (0, _translations.getTranslations)('legalfooter_p5_head')), (0, _translations.getTranslations)('legalfooter_p5_text')), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, (0, _translations.getTranslations)('legalfooter_p6_head')), (0, _translations.getTranslations)('legalfooter_p6a_text'), /*#__PURE__*/_react["default"].createElement("a", {
        href: (0, _translations.getTranslations)('legalfooter_morningstar_nav'),
        target: "_blank",
        rel: "noopenere noreferrer",
        className: "LegalFooter_link"
      }, (0, _translations.getTranslations)('legalfooter_morningstar_text')), (0, _translations.getTranslations)('legalfooter_p6b_text')), /*#__PURE__*/_react["default"].createElement("p", null, (0, _translations.getTranslations)('legalfooter_p7_text')), /*#__PURE__*/_react["default"].createElement("br", null))))));
    }
  }]);

  return LegalFooter;
}(_react["default"].Component);

_defineProperty(LegalFooter, "propTypes", {
  programDescriptionLink: _propTypes["default"].string
});

var _default = LegalFooter;
exports["default"] = _default;